/**
 * @generated SignedSource<<0297ee405205b4fd0a61b096ef385e4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SaveSearchButton_itemSearch">;
  readonly " $fragmentType": "PdpRespSidebarButtons_itemSearch";
};
export type PdpRespSidebarButtons_itemSearch$key = {
  readonly " $data"?: PdpRespSidebarButtons_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarButtons_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SaveSearchButton_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "fb743865b95507f7114580af97e213bb";

export default node;
